import { useDispatch } from "src/store";

import { showDetails } from "@dashboard/devices/store";
import { MinimalTableCell } from "@shared/table/MinimalTableComponents";

type Props = {
    id: number;
    value: string;
};

export const RolloutTableCell = (props: Props) => {
    const { id, value } = props;
    const dispatch = useDispatch();

    const onRollout = () => {
        dispatch(showDetails({ type: "rollout", selectedId: id }));
    };

    return <MinimalTableCell onClick={onRollout}>{value}</MinimalTableCell>;
};
